import React, { useContext, useState } from 'react';
import { Components } from '../../../../utils/types';
import { DailySprintSelectionPage } from './DailySprintSelectionPage';

import { DaiyCeremonyPageStoryBoard } from './DailyStoryPage';
import { DaiyCeremonyPageTaskBoard } from './DailyTaskPage';
import { SelectionContext } from '../../../../contexts/SelectionContext';

export const DaiyCeremonyFrame = () => {
    const [selectedSprint, setSelectedSprint] = useState<Components.Schemas.WBSElementDeltaDTO>();
    const [sprintView, setSprintView] = useState<'Task' | 'Story'>('Story');

    const toggleView = () => {
        setSprintView((cur) => (cur === 'Story' ? 'Task' : 'Story'));
    };

    return !selectedSprint ? (
        <DailySprintSelectionPage setSelectedSprint={setSelectedSprint} />
    ) : sprintView === 'Story' ? (
        <DaiyCeremonyPageStoryBoard selectedSprint={selectedSprint} toggleView={toggleView} />
    ) : (
        <DaiyCeremonyPageTaskBoard selectedSprint={selectedSprint} toggleView={toggleView} />
    );
};
